import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import styles from './styles.pcss';

const cn = classNames.bind(styles);

export const ClickableLayout = ({ href, onClick, srOnlyText, isClickable, children, testName }) => {
  if (!isClickable) {
    return children;
  }

  if (onClick) {
    return (
      <div className={cn('component')} data-component={`${testName}-component`}>
        <button
          className={cn('button')}
          data-component={`${testName}-btn`}
          onClick={onClick}
          type="button"
        >
          <div className={cn('sr-only')}>{srOnlyText}</div>
        </button>
        {children}
      </div>
    );
  }

  return (
    <div className={cn('component')}>
      <a className={cn('link')} href={href}>
        <div className={cn('sr-only')}>{srOnlyText}</div>
      </a>
      {children}
    </div>
  );
};

ClickableLayout.propTypes = {
  testName: PropTypes.string,
  isClickable: PropTypes.bool,
  srOnlyText: PropTypes.string,
  href: PropTypes.string,
  children: PropTypes.node,
  onClick: PropTypes.func,
};
